import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { ArticuloService } from '../../services/articulo.service';
import { TipoService } from '../../services/tipo.service';
import { CategoriaService } from '../../services/categoria.service';
import { SubcategoriaService } from '../../services/subcategoria.service';
import { SocioService } from '../../services/socio.service';

import { Socio } from '../../model/socio';
import { Articulo } from '../../model/articulo';
import { Consorcio } from '../../model/consorcio';
import { Tipo } from '../../model/tipo';
import { Categoria } from '../../model/categoria';
import { Subcategoria } from '../../model/subcategoria';


@Component({
  selector: 'app-articulo-mantenimiento',
  templateUrl: './articulo-matenimiento.component.html',
  styleUrls: ['./articulo-matenimiento.component.css']
})
export class ArticuloMatenimientoComponent implements OnInit {

  @Input() consorcio: Consorcio = new Consorcio();
  @Input() articuloSeleccionado: Articulo;
  @Output() onReturn = new EventEmitter();

  public articulo: Articulo = new Articulo();
  public estadoBorrar: boolean = false;
  public estadoEditar: boolean = false;

  public tipoAlmacenamientos: Tipo[];
  public unidadBases: Tipo[];
  public unidadPaquetes: Tipo[];
  public tipoFragilidades: Tipo[];
  public tipoPeligrosidades: Tipo[];

  public categorias: Categoria[];
  public subcategorias: Subcategoria[];

  public tipoAlmacenamiento: Tipo = new Tipo();
  public unidadBase: Tipo = new Tipo();
  public unidadPaquete: Tipo = new Tipo();
  public tipoFragilidad: Tipo = new Tipo();
  public tipoPeligrosidad: Tipo = new Tipo();

  public proveedores: Socio[];

  public categoria: Categoria = new Categoria();
  public subcategoria: Subcategoria = new Subcategoria();

  public errorMessage: any;
  public cat: string;
  public query: any;
  public prefijo:string;

  constructor(
    private _articuloService: ArticuloService,
    private _tipoService: TipoService,
    private _categoriaService: CategoriaService,
    private _subcategoriaService: SubcategoriaService,
    private _socioService: SocioService
  ) { }

  ngOnInit() {

    this.prefijo = "";

    if (sessionStorage.getItem("login") === null) {
      window.location.href = "/";
    }

    if (this.articuloSeleccionado != null) {
      this.articulo = this.articuloSeleccionado;
      this.estadoEditar = true;
      this.cargarDatosEditar();
    }else{

    this.prefijo = this.consorcio.documentoPrefijo;

    }

    this.getTipos();
    this.getCategorias();
    this.subcategorias = null;

    this.query = {
      codigoConsorcio: this.consorcio.codigoConsorcio,
      tipo: "PROVEEDOR"
    };

    this._socioService.getSocios(this.query)
      .subscribe(
      data => this.proveedores = data,
      err => {
        console.clear();
        console.log(err._body);

      });

  }
  totalPaqueteTarima(){
    this.articulo.paquetesTarima = (this.articulo.paquetesBaseTarima*this.articulo.paquetesAlturaTarima);
  }

  cargarDatosEditar() {

    this.query = {
      codigoConsorcio: this.consorcio.codigoConsorcio,
      codigoCategoria: this.articuloSeleccionado.codigoCategoria !== "null" ? this.articuloSeleccionado.codigoCategoria : null
    };

    this._subcategoriaService.getSubcategorias(this.query)
      .subscribe(
      data => {
        this.subcategorias = data;
      },
      err => {
        console.log(err);
      });

  }

  getCategorias() {
    this._categoriaService.getCategorias(this.consorcio)
      .subscribe(
      data => this.categorias = data,
      err => {
        console.log(err);
      });
  }

  cargarSubCategorias(categoria: string) {
    this.subcategorias = null;
     this.query = {
      codigoConsorcio: this.consorcio.codigoConsorcio,
      codigoCategoria: categoria !== "null" ? categoria : null
    };

    this._subcategoriaService.getSubcategorias(this.query)
      .subscribe(
      data => this.subcategorias = data,
      err => {
        console.log(err);
      });
  }

  getTipos() {
    this._tipoService.getTipos()
      .subscribe(
      data => {
        this.tipoAlmacenamientos = data.filter(tipo => tipo.tipo === "ALMACENAJE");
        this.tipoFragilidades = data.filter(tipo => tipo.tipo === "FRAGILIDAD");
        this.tipoPeligrosidades = data.filter(tipo => tipo.tipo === "PELIGROSIDAD");
        this.unidadBases = data.filter(tipo => tipo.tipo === "PRESENTACIONBASE");
        this.unidadPaquetes = data.filter(tipo => tipo.tipo === "PRESENTACIONEMPAQUE");
      },
      err => {
        console.log(err);
      });
  }

  onSubmit() {
    if (this.articulo.id === undefined) {
      this.articulo.id = 0;
      this.articulo.codigoArticulo = this.consorcio.documentoPrefijo+"-"+this.articulo.codigoArticulo;
    }
    if(this.articulo.codigoBarraUnidad === this.articulo.codigoBarraBulto){
      alert("Código Barra Unidad no puede ser igual a Código Barra Bulto");
      return;
    }
    this.articulo.codigoConsorcio = this.consorcio.codigoConsorcio;

    this.articulo.gestionLote === undefined ? this.articulo.gestionLote = false : this.articulo.gestionLote = this.articulo.gestionLote;
    this.articulo.controlSeries === undefined ? this.articulo.controlSeries = false : this.articulo.controlSeries = this.articulo.controlSeries;
    this.articulo.estado === undefined ? this.articulo.estado = false : this.articulo.estado = this.articulo.estado;

    this._articuloService.insert(this.articulo).subscribe(
      result =>{
        { 
        if(result.Resultado === "codigoArticulo ya existe en la base de datos"){
            alert("El código del Artículo ya existe");
        }else{
          if(result.Resultado === false){
            alert("Ha ocurrido un error...");  
          }else{
            this.onSubmitSuccess(result);
          }
        }
      }
      }, 
      err => {
        console.log(err);
      });
  }

  onSubmitSuccess(data: any) {
    this.regresar();
  }


  /* Navegación */

  regresar() {
    this.onReturn.emit();
  }

  solicitaBorrar() {
    this.estadoBorrar = true;
  }
  
  solicitudBorrarCancelar() {
    this.estadoBorrar = false;
  }

  borrarRegistro() {
    this._articuloService.delete(this.articulo).subscribe(
      result => this.regresar(),
      err => {
        console.log(err);
      });
  }

}



// WEBPACK FOOTER //
// D:/TPL ILG/3PL_ILG/src/app/components/articulo-matenimiento/articulo-matenimiento.component.ts